// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".list-test[data-v-ecaae08e]{-webkit-column-count:1;-moz-column-count:1;column-count:1}dt[data-v-ecaae08e]{width:15px;height:15px}dd[data-v-ecaae08e],dt[data-v-ecaae08e]{display:inline-block}dd[data-v-ecaae08e],dl[data-v-ecaae08e]{margin:5px}dl[data-v-ecaae08e]{-webkit-column-count:2;-moz-column-count:2;column-count:2}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
